import { gql } from '@apollo/client';
import { EMAIL_TEMPLATE_FIELDS } from './EmailTemplate.fragment';
import { SITE_FIELDS } from './Site.fragment';

export const PROMO_ALERT_FIELDS = gql`
  ${SITE_FIELDS}
  ${EMAIL_TEMPLATE_FIELDS}
  fragment PromoAlertFields on emailPromoAlert {
    id
    body
    buttonLabel
    buttonUrl
    buttonColor
    buttonTextColor
    photoType
    photoUrl
    emailTemplateId
    mailchimpCampaignId
    trendingEvents
    trendingNews
    utm
    trendingPlaces
    title
    endDate
    isSent
    isScheduled
    startDate
    sendDate
    sendTime
    siteId
    style
    subject
    site {
      ...SiteFields
    }
    emailTemplate {
      ...EmailTemplateFields
    }
  }
`;
